import { APIDelete, APIGet, APIPost, APIPut, APIUrl, AdminType } from "api/protocols";
import { CancelToken } from "axios";
export type TGetEventApplication = {
    id?: string | number;
    event_type: "league" | "tournament";
    event_id: number;
    template_id?: number;
};

type TPostEventApplicationTeeSheet = {
    event_type: "league" | "tournament";
    event_id: number;
    start_date: string;
    end_date?: string;
    start_time: string;
    end_time: string;
    recurrence_type: "does_not_repeat" | "daily"| "weekly" | "monthly" | "annually" | "every_week_day" | "custom";
    repeat_amount?: number;
    interval?: "day" | "week" | "month" | "year";
    weekdays?: Array<number>;
    monthly_rule_type?: "day_of_month" | "nth_weekday";
    ends_type?: "" | "on" | "after";
    ends_on_date?: string;
    ends_after_occurrences?: number;
    division_id: number;
    course_id: number;
    //shotgun
    application_type?: "regular" | "shotgun";
    shotgun_template_id?: number;
    duration?: number;
    lead_time?: number;
    turn_division_id?: number;
    booking_category_ids?: Array<number>;
};

type TPutEventApplicationTeeSheet = {
    id: number;
    event_type: "league" | "tournament";
    event_id: number;
    start_date: string;
    end_date?: string;
    start_time: string;
    end_time: string;
    recurrence_type: "does_not_repeat" | "daily"| "weekly" | "monthly" | "annually" | "every_week_day" | "custom";
    repeat_amount?: number;
    interval?: "day" | "week" | "month" | "year";
    weekdays?: Array<number>;
    monthly_rule_type?: "day_of_month" | "nth_weekday";
    ends_type?: "" | "on" | "after";
    ends_on_date?: string;
    ends_after_occurrences?: number;
};

type TPostEventApplicationTemplate = {
    event_type: "league" | "tournament";
    event_id: number;
    template_id: number;
    start_time: string;
    end_time: string;
    division_id: number;
    course_id: number;

    //shotgun
    application_type?: "regular" | "shotgun";
    shotgun_template_id?: number;
    duration?: number;
    lead_time?: number;
    turn_division_id?: number;
    booking_category_ids?: Array<number>;
};

type TPutEventApplicationTemplate = {
    id: number;
    start_time: string;
    end_time: string;
};

export type TEventApplication = {
    id: number;
    facility_id: number;
    division_id: number;
    course_id: number;
    event_type: "league" | "tournament";
    event_id: number;
    template_id?: number;
    start_date: string;
    end_date?: string;
    start_time: string;
    end_time: string;
    recurrence_type?: "does_not_repeat" | "daily"| "weekly" | "monthly" | "annually" | "every_week_day" | "custom";
    repeat_amount?: number;
    interval?: "day" | "week" | "month" | "year";
    weekdays?: Array<number>;
    monthly_rule_type?: "day_of_month" | "nth_weekday";
    ends_type?: "on" | "after";
    ends_on_date?: string;
    ends_after_occurrences?: number;
    created_by_user_id?: number;
    created_by: {id: number; full_name: string};
    template?: {id: number; name: string};
    application_type: "regular" | "shotgun";
    shotgun_application_id?: number;
};

export async function GetEventApplication(params: TGetEventApplication, useGlobalLoader: boolean, token?: CancelToken) {
    return await APIGet<Array<TEventApplication>>(APIUrl(AdminType.FacilityAdmin, "/event/application"), params, useGlobalLoader, token);
}

// Live tee sheet
export async function PostEventApplicationTeeSheet(params: TPostEventApplicationTeeSheet, useGlobalLoader: boolean) {
    return await APIPost(APIUrl(AdminType.FacilityAdmin, "/event/application/tee-sheet"), params, useGlobalLoader);
}

export async function DeleteEventApplicationTeeSheet(params: {id: number}, useGlobalLoader: boolean) {
    return await APIDelete(APIUrl(AdminType.FacilityAdmin, "/event/application/tee-sheet"), params, useGlobalLoader);
}

export async function PutEventApplicationTeeSheet(params: TPutEventApplicationTeeSheet, useGlobalLoader: boolean) {
    return await APIPut(APIUrl(AdminType.FacilityAdmin, "/event/application/tee-sheet"), params, useGlobalLoader);
}

// Templates
export async function PostEventApplicationTemplate(params: TPostEventApplicationTemplate, useGlobalLoader: boolean) {
    return await APIPost(APIUrl(AdminType.FacilityAdmin, "/event/application/template"), params, useGlobalLoader);
}

export async function PutEventApplicationTemplate(params: TPutEventApplicationTemplate, useGlobalLoader: boolean) {
    return await APIPut(APIUrl(AdminType.FacilityAdmin, "/event/application/template"), params, useGlobalLoader);
}

export async function DeleteEventApplicationTemplate(params: {id: number}, useGlobalLoader: boolean) {
    return await APIDelete(APIUrl(AdminType.FacilityAdmin, "/event/application/template"), params, useGlobalLoader);
}